export default __webpack_public_path__ + "static/media/Slide-3.91deb5df.png";